module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAABOUlEQVRIie2WsWrCUBSGv6iICKVS6JLFJYt0DCXF0QfoC9jB1TfwCXwB20lwK91KqYMv0DfpA7R0qovKhXPlGtKYnCQ41H9Kcu45X27O+bnxwjBEqRqw0aTWtETgEZhoEhtKoIGNgS3wCTznSdbsdAhM5doDFsCgSuidQDznWRN4BXpVQAPgXSBxXUrsukyoKbY6UtS81BJolwFtS7Egw9oIeAHqRaB1KRJlAFrdA7PUor7vp8WfgIccQKtbYA18JAXTdmq9qNVU7JUZ6npRqz89nASNEryolfXwTRrUjn2SF7UyHn5z7eZCs3hRqwMPW2geL2q197CxjOndHOgDvzLqrZKBX1K7C1w05HgaOQtMD75Lhl65N0UOcbVOAtX8OWxjn9/MRKdq6E+sR7ln4P/09Aw9Q4sL2AG5SyoB3uRdKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icon_sy.png
// module id = jFgu
// module chunks = 10